import React, {
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction
} from 'react';

export interface Branch {
  branchId: number;
  branchName: string;
  branchDomain: string;
}

interface BranchContextInterface {
  branches: Branch[]; // List of branches
  selectedBranch: Branch | null; // Currently selected branch
  setSelectedBranch: Dispatch<SetStateAction<Branch | null>>;
  setBranches: Dispatch<SetStateAction<Branch[]>>; // Function to update branches
}

export const BranchContext = createContext<BranchContextInterface | undefined>(
  undefined
);

export const BranchProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [branches, setBranches] = useState<Branch[]>([]); // Initialize branches
  const [selectedBranch, setSelectedBranch] = useState<Branch | null>(null); // Initialize selected branch

  return (
    <BranchContext.Provider
      value={{ branches, selectedBranch, setSelectedBranch, setBranches }}
    >
      {children}
    </BranchContext.Provider>
  );
};

export const useBranchContext = () => {
  const context = useContext(BranchContext);
  if (context === undefined) {
    throw new Error('useBranchContext must be used within a BranchProvider');
  }
  return context;
};
